import { useState, useEffect } from "react";
import { apiUrl } from "utils/api";

const useGetCataloguesWithAllItem = (catalogueId) => {
  const [subGroupedAllData, setSubGroupedAllData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCatalogueGroupedData = async () => {
      try {
        const response = await fetch(
          apiUrl(`getCataloguesWithAllItem/${catalogueId}`),
        );

        if (!response.ok) {
          throw new Error("Failed to fetch grouped catalogue data");
        }

        const result = await response.json();
        console.log("data", result.data);
        setSubGroupedAllData(result.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCatalogueGroupedData();
  }, [catalogueId]);

  return { subGroupedAllData, loading, error };
};

export default useGetCataloguesWithAllItem;
